// File: /components/article/ArticleHeader.js
import React from "react";
import { Typography, CardContent } from "@mui/material";

export default function ArticleHeader({ article }) {
  const articleTitle = article?.title || "Article Title";
  const articleDate = article?.publishedAt || "2023-01-01";

  // Handle Firestore timestamp format {_seconds, _nanoseconds}
  let dateObj;
  if (articleDate?._seconds) {
    dateObj = new Date(articleDate._seconds * 1000);
  } else {
    dateObj = new Date(articleDate);
  }

  const formattedDate = dateObj.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <CardContent sx={{ textAlign: "left", width: "100%", mt: 2 }}>
      <header>
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "text.primary" }}
        >
          {articleTitle}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.subtle" }}
        >
          Published on {formattedDate}
        </Typography>
      </header>
    </CardContent>
  );
}
